import React, { ChangeEvent, useEffect, useState } from 'react'
import { Input, Label, Switch } from './styles'

export const ToggleSwitch = ({
  label,
  value,
  onChange,
}: {
  label: string
  value: boolean
  onChange: (value: boolean) => void
}) => {
  const [checked, setChecked] = useState(value)

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setChecked(e.target.checked)
    onChange(e.target.checked)
  }

  useEffect(() => {
    setChecked(value)
  }, [value])

  return (
    <Label>
      <span>{label}</span>
      <Input checked={checked} type="checkbox" onChange={handleChange} />
      <Switch />
    </Label>
  )
}
